<template>
  <div class="friends row justify-content-center">
    <b-modal ref="removeConfirmation" id="removeConfirmation" title="Ta bort vän" @ok="removeAction" @cancel="removeCancel" close-title="Nej" ok-title="Ja">
        <span>Vill du ta bort din vän?</span>
    </b-modal>
    <div class="col-md-8">
        <div class="row">
            <div class="col-sm-7">
                <h2>Vänner</h2>
            </div>
            <div class="col-sm">
                <div class="input-group">
                    <input type="text" v-model="username" class="form-control" placeholder="Användarnamn" required autofocus>
                    <span class="input-group-btn">
                        <button @click="create(username)" type="button" class="btn btn-md btn-primary">Skicka</button>
                    </span>
                </div>
            </div>
        </div>
        <table class="table table-bordered table-striped">
            <thead>
                <tr>
                    <th>Användarnamn</th>
                    <th>Hantera</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(friend, index) in friends">
                    <td>{{ friend.username }}</td>
                    <td>
                        <button class="btn btn-primary" v-on:click="selectForRemoval({friend, index})" v-if="friend.accepted">Ta bort</button>
                        <button class="btn btn-primary" v-on:click="accept(friend)" v-if="!friend.accepted">Acceptera</button>
                        <button class="btn btn-primary" v-on:click="remove({friend, index})" v-if="!friend.accepted">Neka</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'friends',
    computed: {
        friends () {
            return this.$store.state.friend.friends
        }
    },
    data () {
        return {
            username: '',
            friend: null
        }
    },
    mounted () {
        this.refresh()
    },
    methods: {
        ...mapActions({
            refresh: 'friend_list',
            create: 'friend_post',
            accept: 'friend_put',
            remove: 'friend_delete'
        }),
        selectForRemoval: function ({friend, index}) {
            this.friend = {friend, index}
            this.$refs.removeConfirmation.show()
        },
        removeAction: function () {
            this.remove(this.friend)
        },
        removeCancel: function () {
            this.friend = null
        },
        sendFriendRequest: function () {
            this.create(this.username)
            this.username = ''
        }
    }
}
</script>

<style lang="scss">
    .friends-table {
        margin-top: 1rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Friends.vue